import { render, staticRenderFns } from "./AppLayoutSuccesFormDiCambio.vue?vue&type=template&id=4737951e&"
import script from "./AppLayoutSuccesFormDiCambio.vue?vue&type=script&lang=js&"
export * from "./AppLayoutSuccesFormDiCambio.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutSuccesFormDiCambio.vue?vue&type=style&index=0&id=4737951e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
